import APIModel from "../APIModel";

export default class ExpertiseTypes extends APIModel {
  private readonly resourceUrl: string;

  constructor() {
    super();
    this.resourceUrl = "expertise_types";
  }

  /* GET */

  async getData(params: object): Promise<any> {
    return await this.http.get(`${this.resourceUrl}`, params);
  }

  async getForEdit(id: number): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/${id}/edit`);
  }

  async getList(params: any = {}, headers: any = {}): Promise<any> {
    return await this.http
      .setHeaders(headers)
      .get(`${this.resourceUrl}/list`, params);
  }

  async getSpeciesList(params: any = {}, headers: any = {}): Promise<any> {
    return await this.http
        .setHeaders(headers)
        .get(`${this.resourceUrl}/species_list`, params);
  }

  /* POST */

  async create(payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .post(`${this.resourceUrl}`, payload);
  }

  /* PATCH */

  async edit(id: number, payload: object): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .post(`${this.resourceUrl}/${id}?_method=PATCH`, payload);
  }

  /* DELETE */

  async delete(id: any): Promise<any> {
    return await this.http.delete(`${this.resourceUrl}`, { id });
  }
}
